import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_17 = { class: "col-md-2 mt-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Batch List")
  ])
], -1)
const _hoisted_20 = { class: "card mb-5 mb-xl-10" }
const _hoisted_21 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_22 = { class: "row mt-1 w-100 m-0" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "div pb-2" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 mt-1 text-end\" data-v-54b12dc8=\"\"><button type=\"button\" class=\"btn btn-dark fs-7 p-2 rounded-0\" title=\"Download Xlse\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-excel fs-5\" data-v-54b12dc8=\"\"></i> Excel </button><button type=\"button\" class=\"btn btn-warning fs-7 p-2 rounded-0\" title=\"Download PDF\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-pdf fs-5\" data-v-54b12dc8=\"\"></i> PDF </button><button type=\"button\" class=\"btn btn-primary fs-7 p-2 rounded-0\" title=\"Download CSV\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-csv fs-5\" data-v-54b12dc8=\"\"></i> CSV </button></div>", 1)
const _hoisted_26 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_27 = { class: "collapse show" }
const _hoisted_28 = { class: "card-body border-top p-6" }
const _hoisted_29 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_BatchDrawer = _resolveComponent("BatchDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    options: _ctx.optionsTranche,
                    mode: "tags",
                    "clear-on-select": false,
                    placeholder: "Select Tranche",
                    "close-on-select": false,
                    searchable: true,
                    "create-option": true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    options: _ctx.optionsTPartner,
                    mode: "tags",
                    "clear-on-select": false,
                    placeholder: "Select Training Partner",
                    "close-on-select": false,
                    searchable: true,
                    "create-option": true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course_Info, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getBatchList())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_18
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control ps-10 w-200px mt-1 form-control-sm",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems())),
                                style: {"height":"1em"},
                                placeholder: "Search"
                              }, null, 544), [
                                [_vModelText, _ctx.search]
                              ])
                            ])
                          ]),
                          _hoisted_25
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.batchInfo,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-sl": _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.id), 1)
                                ]),
                                "cell-tranche": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.tranche_info.label), 1)
                                ]),
                                "cell-entity": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.entity_info.entity_short_name), 1)
                                ]),
                                "cell-ins_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.institute_info.institute_name), 1)
                                ]),
                                "cell-course_name": _withCtx(({ row: industry }) => [
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    href: 
                                `${this.VUE_APP_DOPTOR}/course/course-detail/` +
                                industry?.course_info?.id
                              ,
                                    class: "form_link",
                                    "data-search-type": "course",
                                    "data-search-key": "",
                                    title: "Training Course"
                                  }, _toDisplayString(industry.course_info.course_name), 9, _hoisted_30)
                                ]),
                                "cell-batch_number": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.batch_sequence_number), 1)
                                ]),
                                "cell-trainee_count": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.training_capacity), 1)
                                ]),
                                "cell-term": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.total_term), 1)
                                ]),
                                "cell-start_date": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.start_date ? _ctx.moment(industry.start_date).format('DD-MM-YYYY'): ''), 1)
                                ]),
                                "cell-end_date": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.end_date ?_ctx.moment(industry.end_date).format('DD-MM-YYYY'): ''), 1)
                                ]),
                                "cell-lead_trainer": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.lead_trainer), 1)
                                ]),
                                "cell-associate_trainer": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.associate_trainer), 1)
                                ]),
                                "cell-actions": _withCtx(({ row: industry }) => [
                                  _createElementVNode("a", {
                                    href: 
                                `${this.VUE_APP_TMS}/course-batch/view/` +
                                industry?.id
                              ,
                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                    "data-search-type": "batch",
                                    "data-search-key": "2005",
                                    title: "Batch View",
                                    target: "_blank"
                                  }, _hoisted_33, 8, _hoisted_31),
                                  (_ctx.actionEdit)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_batch_update",
                                        onClick: ($event: any) => (_ctx.edit(industry.id)),
                                        id: "kt_drawer_batch_update_button",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_36, 8, _hoisted_34))
                                    : _createCommentVNode("", true),
                                  (_ctx.actionDelete)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.Delete(industry.id)),
                                        class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                      }, _hoisted_39, 8, _hoisted_37))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_BatchDrawer)
  ], 64))
}